import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { LinkButton, Button } from './buttons';
import { Icon } from './icons';

/**
 * "Nächster Schritt": one calm line on a page saying what is obviously open, with exactly one button that leads there.
 * Purely presentational: pages pass text and action from data they already have (insights, checklist, guide), so the
 * hint never computes its own readiness. Renders nothing without text. The button is secondary: the page header keeps
 * the one primary action of the page.
 */
export function NextStep({
  text,
  sub,
  action,
}: {
  text: ReactNode | null | undefined;
  sub?: ReactNode;
  action?: { label: string; to?: string; onClick?: () => void };
}) {
  const { t } = useTranslation('common');
  if (!text) return null;
  return (
    <section className="next-step" aria-label={t('nextStep.label')}>
      <span className="next-step-icon" aria-hidden>
        <Icon name="arrowRight" size={20} strokeWidth={2} />
      </span>
      <span className="next-step-text">
        <span className="next-step-label">{t('nextStep.label')}</span>
        <strong>{text}</strong>
        {sub && <span className="small muted">{sub}</span>}
      </span>
      {action &&
        (action.to ? (
          <LinkButton size="sm" variant="secondary" to={action.to}>
            {action.label}
          </LinkButton>
        ) : (
          <Button size="sm" variant="secondary" onClick={action.onClick}>
            {action.label}
          </Button>
        ))}
    </section>
  );
}
